import React from 'react';
import { MDBRow, MDBCol, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import LeadCard from './ComponentFragments/LeadCard';
import Colors from '../Styles/Colors';

export default class Leads extends React.Component {

    constructor(props) {
        super();
        this.state = {
            leadsList: [],
            managerList: []
        }

        this.dataLayer = new DataLayer();

        this.loadLeads = this.loadLeads.bind(this);
        this.loadManagers = this.loadManagers.bind(this);

        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
    }

    componentWillMount() {
        this.loadManagers();
        this.loadLeads(false);
        this.props.loaderOff();
    }

    async loadLeads(includeClosed) {
        this.props.loaderOn();
        let response = await this.dataLayer.Get(`/lead/getallleads?includeclosed=${includeClosed}`);
        console.log(response.data);
        this.setState({ leadsList: response.data });
        this.props.loaderOff();
    }

    async loadManagers() {
        this.props.loaderOn();
        let managerList = [];

        if (this.TMAUser.data.statusCode1 == 'T') {

            let result = await this.dataLayer.Get('/teamleader/getunitslist');
            result.data.data.forEach((unit) => managerList.push({ value: unit.sfId, name: unit.managerName }));
        }

        this.setState({ managerList });
        this.props.loaderOff();
    }

    render() {

        if (this.TMAUser.data.statusCode1 == 'T') {
            var myLeads = this.state.leadsList.filter((lead) => lead.sfId == lead.teamLeaderId);
            var teamLeads = this.state.leadsList.filter((lead) => lead.sfId != lead.teamLeaderId);
            if (myLeads == null) { myLeads = [] }
            if (teamLeads == null) { teamLeads = [] }
        }

        let leadCount = this.state.leadsList.length;

        return (
            <div>
                <Header headerText="Mobile Leads" hideSearch={true} />
                <h5>You have {(leadCount === 1) ? (<span>{leadCount} lead</span>) : (<span>{leadCount} leads</span>)}</h5>
                {
                    (this.TMAUser.data.statusCode1 == 'T') ?
                        (
                            <div>
                                <MDBRow className="mb-5">
                                    {
                                        myLeads.map((lead) => {
                                            return (
                                                <MDBCol xl="4" lg="6" md="6" sm="12">
                                                    <LeadCard
                                                        {...this.props}
                                                        lead={lead}
                                                        managerList={this.state.managerList}
                                                        loadLeads={this.loadLeads}
                                                    />
                                                </MDBCol>
                                            )
                                        })
                                    }
                                </MDBRow>

                                <Header headerText="Manager Assigned Leads" hideSearch={true} />
                                <MDBRow>
                                    {
                                        teamLeads.map((lead) => {
                                            return (
                                                <MDBCol xl="4" lg="6" md="6" sm="12">
                                                    <LeadCard
                                                        {...this.props}
                                                        lead={lead}
                                                        managerList={this.state.managerList}
                                                        loadLeads={this.loadLeads}
                                                        hideCloseButton={true}
                                                    />
                                                </MDBCol>
                                            )
                                        })
                                    }
                                </MDBRow>
                            </div>
                        ) : (
                            <MDBRow>
                                {
                                    this.state.leadsList.map((lead) => {
                                        return (
                                            <MDBCol xl="4" lg="6" md="6" sm="12">
                                                <LeadCard
                                                    {...this.props}
                                                    lead={lead}
                                                    managerList={this.state.managerList}
                                                    loadLeads={this.loadLeads}
                                                />
                                            </MDBCol>
                                        )
                                    })
                                }
                            </MDBRow>
                        )
                }

            </div>
        );
    }
}